<template>
    <navigation />

    <promo-header />

    <section class="section section-blue">

        <div class="container">

            <div class="row">

                <div class="col-lg-8">

                    <h2 class="mb-4">
                        Psalms
                    </h2>

                    <h5>Series Aims</h5>
                    <ul>
                        <li>
                            To teach that ultimate satisfaction and joy in life come from living the way that God
                            prescribes in his word.
                        </li>
                        <li>
                            To understand that God has revealed himself generally in creation and
                            specifically in the Bible.
                        </li>
                        <li>
                            To teach that God is intimately involved in every aspect of our lives as Christians to guide,
                            protect and bring fulfilment.
                        </li>
                        <li>
                            To teach that even when we stray from living God's way he is willing to forgive,
                            cleanse and fully restore us.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Overview</h5>
                    <p>
                        This series can either be used as a block of four lessons or as four
                        stand alone lessons whenever a 'filler' session is required in your regular teaching programme.
                    </p>

                    <ul>
                        <li>
                            Psalm 1 is a wisdom psalm and describes two distinct ways of living which have two very different destinies.
                            It can be used evangelistically to invite children to live God's way in order to experience God's blessing
                            and not be destroyed in the final judgment.
                        </li>
                        <li>
                            Psalm 19 explores the different ways in which God has made himself known – creation and the Bible.
                            It could be used apologetically to teach that we can only know what God is like if he chooses to reveal
                            himself to us. He has done this through all that he has made and what he has said in the Bible.
                            It can also be used to encourage children to treasure and read their Bibles.
                        </li>
                        <li>
                            Psalm 23 is a well-known psalm to many adults and one worth getting the children to memorise.
                            It can be used to teach the children that God is not distant, but that he cares deeply for those who follow him.
                            Those who do so can have great confidence in God's ability and willingless to provide all their needs –
                            not only in this life, but also for eternity.
                        </li>
                        <li>
                            Psalm 51 explores the wonder of God's grace poured out on the repentant sinner.
                            All the other psalms clearly teach how we are to live in response to who God is and what he has done.
                            Sadly we don't always get this right! It's therefore a great comfort to know that God also provides
                            a way for those who trust in him to be forgiven, cleansed and restored in their relationship with him.
                        </li>
                    </ul>

                    <h5 class="mt-4">Series Outline</h5>
                    <p>
                        Lesson 1 - God's Way to Live (Psalm 1)
                    </p>
                    <p>
                        Lesson 2 - The God who Speaks (Psalm 19)
                    </p>
                    <p>
                        Lesson 3 - God, My Shepherd (Psalm 23)
                    </p>
                    <p>
                        Lesson 4 - The God Who Forgives (Psalm 51)
                    </p>

                </div>

                <div class="offset-lg-1 col">

                    <promo-sidebar />

                </div>

            </div>

        </div>

    </section>

    <site-footer />
</template>

<script >
import Navigation from "../partials/Navigation.vue";
import SiteFooter from "../partials/SiteFooter.vue";
import PromoHeader from "../partials/PromoHeader.vue";
import PromoSidebar from "../partials/PromoSidebar.vue";

export default {
    name: "Psalms",

    components: {
        PromoSidebar,
        PromoHeader,
        Navigation,
        SiteFooter,
    },

    head() {
        return {
            title: `${this.$app.appName} - Psalms`,
            meta: [
                {
                    name: 'description',
                    content: "o teach that ultimate satisfaction and joy in life come from living the way that God prescribes in his word.",
                },
            ],
        };
    },
};
</script>
